document.addEventListener("DOMContentLoaded", function () {
    const sections = document.querySelectorAll(".faq-activos");

    sections.forEach(section => {
        const questions = section.querySelectorAll(".faq-activos__question");
        const answers = section.querySelectorAll(".faq-activos__answer");
        const indicator = section.querySelector(".faq-activos__indicator");

        if (!questions.length) return;

        function activate(index) {
            questions.forEach(q => q.classList.remove("is-active"));
            answers.forEach(a => a.classList.remove("is-active"));

            const activeQ = questions[index];
            const activeA = answers[index];

            if (activeQ && activeA) {
                activeQ.classList.add("is-active");
                activeA.classList.add("is-active");

                const offset = activeQ.offsetTop;
                indicator.style.willChange = "transform, height";
                indicator.style.transform = `translateY(${offset}px)`;
                indicator.style.height = `${activeQ.offsetHeight}px`;
            }
        }

        activate(0);

        questions.forEach((q, i) => {
            q.addEventListener("click", () => activate(i));
        });

        window.addEventListener("resize", () => {
            const activeIndex = Array.from(questions).findIndex(q => q.classList.contains("is-active"));
            if (activeIndex >= 0) activate(activeIndex);
        });
    });
});